var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMk = function SvgIconMk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.826 23.862a11.94 11.94 0 0 0 5.271-2.185L12.001 12zM10.176.138a11.94 11.94 0 0 0-5.272 2.185L12.001 12zM4.904 21.677a11.94 11.94 0 0 0 5.272 2.185L12 12zM2.324 4.902a11.94 11.94 0 0 0-2.185 5.272L12 11.999zM.139 13.825a11.94 11.94 0 0 0 2.185 5.272L12 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.863 10.174a11.94 11.94 0 0 0-2.185-5.271L12 11.999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.097 2.323A11.94 11.94 0 0 0 13.826.138L12 12zM21.678 19.097a11.94 11.94 0 0 0 2.185-5.272L12.001 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001 16.174a4.174 4.174 0 1 0 0-8.348 4.174 4.174 0 0 0 0 8.348"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 15.13a3.13 3.13 0 1 0 0-6.261 3.13 3.13 0 0 0 0 6.26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconMk;